<div class="flex max-h-[min(85vh,720px)] flex-col overflow-hidden">
  <div class="h-1 shrink-0 bg-gradient-to-r from-[#0B3741] via-[#0B3741] to-[#CC3366]"></div>

  <header class="flex shrink-0 items-start justify-between gap-4 border-b border-gray-200 px-5 py-4 sm:px-6">
    <div class="min-w-0 pt-0.5">
      <p class="text-[10px] font-semibold uppercase tracking-widest text-[#CC3366]">{{ platformName }}</p>
      <h2 class="mt-1 font-bold text-gray-900 text-lg leading-tight">{{ pageTitle() }}</h2>
      <p class="mt-1 text-xs text-gray-500">Documento legal da plataforma</p>
    </div>
    <button
      type="button"
      (click)="close()"
      aria-label="Fechar"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
    >
      <l-icon icon="close" class="text-xl" />
    </button>
  </header>

  <div class="min-h-0 flex-1 overflow-y-auto px-5 py-5 sm:px-6 sm:py-6">
    @if (loading()) {
      <div class="animate-pulse space-y-4 py-2" aria-label="Carregando documento legal">
        <div class="h-4 w-2/3 rounded bg-gray-200"></div>
        <div class="h-3 w-full rounded bg-gray-100"></div>
        <div class="h-3 w-full rounded bg-gray-100"></div>
        <div class="h-3 w-5/6 rounded bg-gray-100"></div>
        <div class="h-3 w-full rounded bg-gray-100"></div>
        <div class="h-3 w-4/5 rounded bg-gray-100"></div>
      </div>
    } @else if (hasError()) {
      <div class="rounded-xl border border-gray-200 bg-gray-50 px-6 py-10 text-center">
        <l-icon icon="error_outline" class="mx-auto mb-3 block text-4xl text-gray-300" />
        <p class="font-semibold text-gray-900 text-sm">Documento indisponível</p>
        <p class="mt-2 text-xs text-gray-500">Tente novamente mais tarde.</p>
      </div>
    } @else {
      <article class="legal-markdown">
        <markdown [data]="markdownContent()" />
      </article>
    }
  </div>

  <footer class="flex shrink-0 justify-end border-t border-gray-200 bg-gray-50/80 px-5 py-3 sm:px-6">
    <button
      type="button"
      (click)="close()"
      class="inline-flex items-center justify-center rounded-lg border border-[#0B3741] px-4 py-2 text-sm font-semibold text-[#0B3741] transition-colors hover:bg-[#0B3741] hover:text-white"
    >
      Fechar
    </button>
  </footer>
</div>
